import React from 'react';
import Box from '@mui/joy/Box';
import Button from '@mui/joy/Button';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';

interface PageInfo {
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  startCursor: string;
  endCursor: string;
}

type Direction = 'next' | 'previous';

interface PaginationProps {
  pageInfo: PageInfo | null;
  isLoadingMore: boolean;
  onPageChange: (direction: Direction) => void;
  canGoNext?: boolean;
  canGoPrevious?: boolean;
}

export default function Pagination({
  pageInfo,
  isLoadingMore,
  onPageChange,
  canGoNext,
  canGoPrevious,
}: PaginationProps) {
  const hasNextPage = canGoNext ?? pageInfo?.hasNextPage ?? false;
  const hasPreviousPage = canGoPrevious ?? pageInfo?.hasPreviousPage ?? false;

  const handlePreviousPage = () => {
    onPageChange('previous');
  };

  const handleNextPage = () => {
    onPageChange('next');
  };

  return (
    <Box
      className="Pagination-laptopUp"
      sx={{
        pt: 2,
        gap: 1,
        display: {
          xs: 'none',
          md: 'flex',
        },
      }}
    >
      <Button
        size="sm"
        variant="outlined"
        color="neutral"
        startDecorator={<KeyboardArrowLeftIcon />}
        onClick={handlePreviousPage}
        disabled={!hasPreviousPage || isLoadingMore}
      >
        Previous
      </Button>

      <Box sx={{ flex: 1 }} />

      <Button
        size="sm"
        variant="outlined"
        color="neutral"
        endDecorator={<KeyboardArrowRightIcon />}
        onClick={handleNextPage}
        disabled={!hasNextPage || isLoadingMore}
      >
        Next
      </Button>
    </Box>
  );
}
